export const TYPES = {
  ALERT: 'alert',
  CONFIRM: 'confirm',
  CONFIRM_DANGER: 'confirmDanger',
  SUCCESS: 'success',
  ERROR: 'error',
  CUSTOM: 'custom',
  LOADING: 'loading',
};
